import * as queries from 'lib/graphql/queries';
import { GraphQLClient } from 'types';
import { poll } from 'lib/poll';

export const createCancellationQuote = async (client: GraphQLClient, bookingId: string) => {
  const createResult = await queries.createCancellation(client, { variables: { bookingId } });
  const cancellationId = createResult.data?.createCancellation.id;

  if (!cancellationId) {
    throw Error('Missing cancellation id');
  }

  const quotedResult = await poll({
    requestFn: () => queries.getCancellation(client, { variables: { bookingId, cancellationId }, fetchPolicy: 'network-only' }),
    isFinished: (result) => result.data.cancellation.state !== 'QUOTING',
  });

  if (quotedResult.data.cancellation.state !== 'QUOTED') {
    throw Error(`Unexpected cancellation state "${quotedResult.data.cancellation.state}"`);
  }

  return quotedResult.data.cancellation;
};
